module.exports = __webpack_public_path__ + "VIPV36.png?f076da997796b30b48f8e6c908556e57";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV36.png
// module id = 132
// module chunks = 0